import { useLocalStore } from 'mobx-react-lite';

import Entities from 'STORE';

interface ISoftUpdatePresenter {
  hasSoftUpdate: boolean;
  onClick(): void;
}

export const useSoftUpdatePresenter = (): ISoftUpdatePresenter => {
  return useLocalStore<ISoftUpdatePresenter>(() => ({
    get hasSoftUpdate(): boolean {
      return Entities.authStore.isNeedSoftUpdate || Entities.authStore.isNeedDesktopSoftUpdate;
    },

    onClick(): void {
      if (Entities.authStore.isNeedDesktopSoftUpdate) {
        window.electronAPI.installUpdate();
      } else {
        window.location.reload();
      }
    },
  }));
};
